const small_banners = [
  {
    image: "images/catbanner-02.jpg",
    big_title: "Smartphones",
    small_title: "Get 50% off on all smartphones",
    description: "sit amet sollicitudin.",
    link: "/products",
  },
  {
    image: "images/catbanner-03.jpg",
    big_title: "Accessories",
    small_title: "Get 50% off on all accessories",
    description: "sit amet, laoreet sollicitudin.",
    link: "/products",
  },
  {
    image: "images/catbanner-04.jpg",
    big_title: "Cameras",
    small_title: "Get 50% off on all cameras",
    description: "sollicitudin.",
    link: "/products",
  },
  {
    image: "images/catbanner-01.jpg",
    big_title: "Headphones",
    small_title: "Get 50% off on all headphones",
    description: "laoreet sollicitudin.",
    link: "/products",
  },
];

export default small_banners;
